import React from 'react';
import { graphql, withPrefix, navigate } from 'gatsby';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import queryString from 'query-string';
import find from 'lodash/find';
import { Index } from 'elasticlunr';
import withRoot from '../withRoot';

import ResourceGrid from '../components/ResourceGrid';
import SearchInput from '../components/SearchInput';
import ResourcePager from '../components/ResourcePager';
import Layout from '../components/Layout';
import container from '../theme/styles/container';
import section from '../theme/styles/section';
import resource from '../theme/styles/resource';
import footerChevron from '../theme/styles/footerChevron';

const styles = () => ({
  ...container,
  ...section,
  ...resource,
  ...footerChevron,
});

class ResourcePage extends React.Component {
  constructor(props) {
    super(props);
    const qs = queryString.parse(this.props.location.search);
    const { query, category, location } = qs;
    this.state = {
      searchQuery: query || '',
      category: category || 'all',
      tmtLocation: location,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(name, value) {
    this.setState({
      ...this.state,
      [name]: value,
    });
  }

  handleSubmit() {
    navigate(
      `/resources/?query=${this.state.searchQuery}&category=${
        this.state.category
      }`,
    );
  }

  getOrCreateIndex = () =>
    this.index
      ? this.index
      : // Create an elastic lunr index and hydrate with graphql query results
        Index.load(this.props.data.siteSearchIndex.index);

  searchResults = query => {
    this.index = this.getOrCreateIndex();
    return this.index
      .search(query)
      .map(({ ref }) =>
        find(this.props.data.allMarkdownRemark.edges, o => o.node.id === ref),
      );
  };

  render() {
    const { classes, location } = this.props;
    // const { currentPage, numPages } = this.props.pageContext;
    const qs = queryString.parse(location.search);
    const qsQuery = qs.query || '';
    const qsCategory = qs.category || 'all';

    const articlesPerPage = 12;
    const results = qsQuery
      ? this.searchResults(qsQuery)
      : this.props.data.allMarkdownRemark.edges;
    const resources = results.filter(
      o => o.node.frontmatter.category === qsCategory || qsCategory === 'all',
    );

    return (
      <Layout location={location} title="Resources for Any Move">
        <div className={classNames(classes.section, classes.container)}>
          <Typography component="h1" variant="h1">
            Browse our Resource Library
          </Typography>
          <SearchInput
            searchQuery={this.state.searchQuery}
            category={this.state.category}
            onSubmit={this.handleSubmit}
            onChange={this.handleChange}
          />
          <ResourceGrid
            resources={resources}
            qs={qs}
            articlesPerPage={articlesPerPage}
          />
          <ResourcePager
            resources={resources}
            qs={qs}
            articlesPerPage={articlesPerPage}
          />
        </div>
        <div className={classes.footerChevronContainer}>
          <img
            src={withPrefix('/img/bottom--alt.svg')}
            alt=""
            className={classes.footerChevron}
          />
        </div>
      </Layout>
    );
  }
}

export default withRoot(withStyles(styles)(ResourcePage));

export const pageQuery = graphql`
  query ResourceIndexQuery {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "DD MMMM, YYYY")
            category
            banner {
              childImageSharp {
                fluid(maxHeight: 400) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          fields {
            slug
          }
          excerpt
        }
      }
    }
    siteSearchIndex {
      index
    }
  }
`;
